module.exports = __webpack_public_path__ + "img/icon_anywhere.29881c30.svg";